import { SessionPayload } from "@models/ISchema";
import { ResultType } from "../context/result.reducer";

const sessionHasIssue = (sessionPayload: SessionPayload): boolean =>
  [
    sessionPayload?.customValidations ?? [],
    sessionPayload?.intervalValidationErrors ?? [],
    sessionPayload?.validationErrors ?? [],
  ].some(errors => errors?.length > 0);

/**
 * True when any edited or created session of the validation result reports a custom, interval or
 * validation error (warnings included). It is the single definition behind the green success card
 * of the validation view and the orange variant of the proposal confirm modal, so both always agree.
 */
export const hasValidationIssues = (
  result: Pick<ResultType, "createValidation" | "resultValidation"> | null | undefined,
): boolean => {
  const creationIssues = (result?.createValidation?.sessionsPayload ?? []).some(sessionHasIssue);
  const editionIssues = (result?.resultValidation?.sessionsPayload ?? []).some(sessionHasIssue);

  return creationIssues || editionIssues;
};
